import { render, staticRenderFns } from "./WelcomeDashboard.vue?vue&type=template&id=9fff5168&scoped=true&"
import script from "./WelcomeDashboard.vue?vue&type=script&lang=js&"
export * from "./WelcomeDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fff5168",
  null
  
)

export default component.exports